// CH-W57 — Video Unit feed (reels) untuk customer. Auto-registered sbg namespace "videos".
import { API_URL } from "@/mainconfig";

const actions = {
   // feed video-only (mengisi grid staggered + sekuens player). params: {page, limit, propertyId, cityId}
   async fetchVideoFeed(_ctx, params = {}) {
      const res = await API_URL.get("/video/feed", { params });
      const body = res?.data || {};
      return { data: Array.isArray(body.data) ? body.data : [], meta: body.meta || {} };
   },
};

export default { namespaced: true, state: {}, mutations: {}, getters: {}, actions };
